import { IQueryConditionHandler } from "./iquerycondition.handler";

import { CompareType } from '../enum/compare-type.enum';
import { ValueType } from '../enum/value-type.enum';
import { RelationType } from '../enum/relation-type.enum';
import { QueryCondition } from '../../entity/querycondition';
import { CheckboxGroupValue } from '../../entity/conditionvalue/checkboxgroupvalue';
import { CheckboxIEnumValue } from '../../entity/controltype/checkbox/ienumvalue';

export class CheckboxGroupHandler implements IQueryConditionHandler{
    convert(qc: QueryCondition) {
        const cbgv = (qc.value as CheckboxGroupValue);
        if(Object.keys(cbgv).length === 0 || Object.keys(cbgv.value).length === 0)
            return [];
        let CheckboxArr = [];
        if(cbgv.value.length === 1){
            return [{
                'FilterField' : qc.fieldCode,
                'Compare' : CompareType.Equal,
                'Value' : (cbgv.value[0]),
                'Relation' : RelationType.And,
                'Expresstype': ValueType.Value
            }]
        }
        cbgv.value.forEach(value => {
            CheckboxArr.push({
                'FilterField' : qc.fieldCode,
                'Compare' : CompareType.Equal,
                'Value' : value,
                'Relation' : RelationType.Or,
                'Expresstype': ValueType.Value
            })
        });
        CheckboxArr[0]['Lbracket'] = '(';
        CheckboxArr[CheckboxArr.length - 1]['Rbracket'] = ')';
        CheckboxArr[CheckboxArr.length -1]['Relation'] = RelationType.And;
        return CheckboxArr;
    }
}